import { gql } from '@apollo/client'

export const CHANGE_CLIENT_THEME = gql`
  mutation CHANGE_CLIENT_THEME($input: ClientThemeInput!) {
    changeClientTheme(input: $input) {
      logo_url
      primary_color
      secondary_color
    }
  }
`

export const UPLOAD_CLIENT_LOGO = gql`
  mutation UPLOAD_CLIENT_LOGO($file: Upload!) {
    uploadClientLogo(file: $file) {
      logo_url
      primary_color
      secondary_color
    }
  }
`
export const REMOVE_CLIENT_LOGO = gql`
  mutation {
    removeClientLogo {
      logo_url
      primary_color
      secondary_color
    }
  }
`
